/**
 * Ein angefangenes Highlight vom Chat zur Karte tragen.
 *
 * „Aus dem Chat heraus" ist einer der drei Wege, auf denen ein Highlight
 * entsteht: man hat den Absatz schon geschrieben, und er soll jetzt auch als
 * Punkt auf der Karte stehen. Der Text muss dabei von einer Seite zur anderen.
 *
 * **Über `sessionStorage` und nicht über die Adresse.** Ein Nachrichtentext
 * gehört nicht in eine URL: er stünde im Verlauf des Browsers, in jedem
 * Lesezeichen und in jedem Bildschirmfoto der Adresszeile. `sessionStorage`
 * endet mit dem Fenster und geht nirgends hin.
 *
 * Abgeholt wird **einmal**: die Karte nimmt die Übergabe entgegen und löscht
 * sie. Sonst schlüge beim nächsten Öffnen der Karte wieder derselbe Bogen auf.
 */

const SCHLUESSEL = 'tb.highlight.uebergabe'

export interface Uebergabe {
  tripId: number
  title: string
  body: string
  /** Wann die Nachricht geschrieben wurde -- als erster Anhalt für die Zeit. */
  at: string | null
}

export function merkeUebergabe(uebergabe: Uebergabe): void {
  try {
    sessionStorage.setItem(SCHLUESSEL, JSON.stringify(uebergabe))
  } catch {
    // Privater Modus, voller Speicher: dann eben ohne Vorbelegung.
  }
}

/** Holt die Übergabe für diese Reise ab und räumt sie weg. */
export function holUebergabe(tripId: number): Uebergabe | null {
  try {
    const roh = sessionStorage.getItem(SCHLUESSEL)
    if (roh === null) return null
    sessionStorage.removeItem(SCHLUESSEL)

    const gelesen = JSON.parse(roh) as Partial<Uebergabe>
    // Für eine andere Reise gedacht: nicht anwenden. Das ist kein
    // Sicherheitsschloss, sondern verhindert einen verwirrenden Bogen.
    if (gelesen.tripId !== tripId) return null

    return {
      tripId,
      title: typeof gelesen.title === 'string' ? gelesen.title : '',
      body: typeof gelesen.body === 'string' ? gelesen.body : '',
      at: typeof gelesen.at === 'string' ? gelesen.at : null,
    }
  } catch {
    return null
  }
}
